export default {
  'pages.home.heroTitle': '分析、复刻或生成爆款带货视频',
  'pages.home.mode.video': '视频生成',
  'pages.home.mode.image': '图片生成',
  'pages.home.myGenerated': '我生成的{type}',
  'pages.home.assetType.video': '视频',
  'pages.home.assetType.image': '图片',
};
